import { useEffect, useState } from "react"
import { Backdrop, CircularProgress, Box, Divider, Grid, Paper, Table, TableCell, TableHead, TableRow, TextField, Typography, TableBody, TableFooter, useMediaQuery, useTheme, Card, CardContent, Chip } from "@mui/material"
import axios from "../api/axios"
import useAuth from '../hooks/useAuth';
import ExportButtons from './ExportButtons';

export default function Consulta(props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [desde, setDesde] = useState("");
    const [hasta, setHasta] = useState("");
    const [rows, setRows] = useState([])
    const [procesando, setProcesando] = useState(false)
    const [totalMovs, setTotalMovs] = useState(0.00)

    const { auth, setAuth } = useAuth();

    useEffect(() => {
        setDesde(getDesde())
        setHasta(getHasta())
    }, [])

    useEffect(()=>{
        actRows();
    }, [desde, hasta])

    const getDesde = () => {
        const cual = new Date();
        var mm = cual.getMonth() + 1;

        var yyyy = cual.getFullYear();
        if (mm < 10) {
            mm = '0' + mm;
        }
        var today = yyyy + '-' + mm + '-01';
        return today;
    }

    const getHasta = () => {
        const cual = new Date();
        var mm = cual.getMonth() + 1;
        var yyyy = cual.getFullYear();

        if (mm == 12) {
            mm = 1
            yyyy++;
        } else {
            mm++;
        }

        let prox = new Date(yyyy, (mm - 1), 1);
        prox.setDate(prox.getDate() - 1)

        mm = prox.getMonth() + 1;
        yyyy = prox.getFullYear();
        let dd = prox.getDate();

        if (mm < 10) {
            mm = '0' + mm;
        }
        if (dd < 10) {
            dd = '0' + dd;
        }

        var today = yyyy + '-' + mm + '-' + dd;
        return today;
    }

    const actRows = async ()=>{
        setProcesando(true)
        let aRows = []
        let total = 0.00
        try {
            const respuesta = await axios.post("movimientos/consulta2", {
                inversionista: auth.inversionista,
                desde: desde,
                hasta: hasta
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data;
            if (data.respuesta == "S") {
                aRows = data.lista;
                data.lista.forEach((row)=>{
                    total = total + parseFloat(row.disponible)
                })
            }
        } catch (error) {
            console.log(error)
        }
        setRows(aRows)
        setTotalMovs(total)
        setProcesando(false)
    }

    const objWait = () => {
        return (
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={procesando}
                onClick={()=>{setProcesando(false)}}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }

    // Renderizar tarjetas para vista móvil
    const renderMobileCards = () => {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, pb: 2 }}>
                {rows.map((row) => {
                    const disponible = parseFloat(row.disponible);
                    const ganancia = parseFloat(row.ganancia);
                    const isPositiveDisp = disponible >= 0;
                    const isPositiveGan = ganancia >= 0;

                    return (
                        <Card
                            key={row.id}
                            sx={{
                                border: '1px solid rgba(30, 58, 95, 0.1)',
                                borderRadius: 2,
                                boxShadow: '0 2px 8px rgba(30, 58, 95, 0.08)'
                            }}
                        >
                            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                                {/* Header con fecha y concepto */}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography sx={{ fontWeight: 600, color: '#1e3a5f', fontSize: '0.85rem' }}>
                                            {row.nombre}
                                        </Typography>
                                        <Typography sx={{ color: '#718096', fontSize: '0.7rem' }}>
                                            {row.fecha}
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* Datos de disponibilidad y ganancias */}
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr',
                                    gap: 1,
                                    pt: 1,
                                    borderTop: '1px solid rgba(30, 58, 95, 0.08)'
                                }}>
                                    {/* Disponibilidad */}
                                    <Box sx={{
                                        p: 1,
                                        background: 'rgba(30, 58, 95, 0.03)',
                                        borderRadius: 1
                                    }}>
                                        <Typography sx={{ color: '#718096', fontSize: '0.65rem', textTransform: 'uppercase', mb: 0.5 }}>
                                            Disponibilidad
                                        </Typography>
                                        <Typography sx={{
                                            color: isPositiveDisp ? '#1e3a5f' : '#dc2626',
                                            fontWeight: 600,
                                            fontSize: '0.85rem'
                                        }}>
                                            {disponible.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                        </Typography>
                                        <Typography sx={{ color: '#4a5568', fontSize: '0.7rem', mt: 0.5 }}>
                                            Acum: {parseFloat(row.acum_disponible).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                        </Typography>
                                    </Box>

                                    {/* Ganancias */}
                                    <Box sx={{
                                        p: 1,
                                        background: 'rgba(212, 175, 55, 0.05)',
                                        borderRadius: 1
                                    }}>
                                        <Typography sx={{ color: '#718096', fontSize: '0.65rem', textTransform: 'uppercase', mb: 0.5 }}>
                                            Ganancias
                                        </Typography>
                                        <Typography sx={{
                                            color: isPositiveGan ? '#d4af37' : '#dc2626',
                                            fontWeight: 600,
                                            fontSize: '0.85rem'
                                        }}>
                                            {ganancia.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                        </Typography>
                                        <Typography sx={{ color: '#4a5568', fontSize: '0.7rem', mt: 0.5 }}>
                                            Acum: {parseFloat(row.acum_ganancia).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                        </Typography>
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    );
                })}
            </Box>
        );
    };

    // Vista móvil
    if (isMobile) {
        return (
            <Box sx={{
                minHeight: "100vh",
                position: "relative",
                p: 1,
                display: 'flex',
                flexDirection: 'column'
            }}>
                {objWait()}

                {/* Header */}
                <Paper sx={{
                    p: 2,
                    mb: 1.5,
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    borderRadius: 2
                }}>
                    <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 700, textAlign: 'center' }}>
                        Consulta de Movimientos
                    </Typography>
                </Paper>

                {/* Filtros de fecha */}
                <Paper sx={{
                    p: 1.5,
                    mb: 1.5,
                    borderRadius: 2,
                    border: '1px solid rgba(30, 58, 95, 0.1)'
                }}>
                    <Grid container spacing={1.5}>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size="small"
                                type="date"
                                label="Desde"
                                value={desde}
                                onChange={(event) => { setDesde(event.target.value) }}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    '& .MuiInputBase-input': { fontSize: '0.85rem' }
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size="small"
                                type="date"
                                label="Hasta"
                                value={hasta}
                                onChange={(event) => { setHasta(event.target.value) }}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    '& .MuiInputBase-input': { fontSize: '0.85rem' }
                                }}
                            />
                        </Grid>
                    </Grid>
                </Paper>

                {/* Resumen */}
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mb: 1.5,
                    px: 1
                }}>
                    <Chip
                        label={`Total: ${rows.length} movimientos`}
                        size="small"
                        sx={{
                            backgroundColor: 'rgba(30, 58, 95, 0.1)',
                            color: '#1e3a5f',
                            fontWeight: 600,
                            fontSize: '0.7rem'
                        }}
                    />
                </Box>

                {/* Lista de movimientos */}
                <Box sx={{
                    flex: 1,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch'
                }}>
                    {renderMobileCards()}
                </Box>
            </Box>
        );
    }

    // Vista desktop
    return (
        <Box sx={{
            minHeight: "100vh",
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            p: 3,
            pt: 4,
            backgroundColor: '#fafafb'
        }}>
            {objWait()}
            <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: 750, lg: 950, xl: 1100 } }}>
                {/* Header */}
                <Paper sx={{
                    p: 2,
                    mb: 2,
                    borderRadius: 2,
                    boxShadow: 3,
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    borderBottom: '3px solid #d4af37'
                }}>
                    <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textAlign: 'center', letterSpacing: 0.5 }}>
                        Consulta de Ganancias
                    </Typography>
                </Paper>

                {/* Filtros */}
                <Paper sx={{
                    p: 2.5,
                    mb: 2,
                    borderRadius: 2,
                    boxShadow: 3,
                    border: '1px solid rgba(30, 58, 95, 0.1)'
                }}>
                    <Typography variant="body2" sx={{ color: '#1e3a5f', fontWeight: 600, mb: 1.5, display: 'block', textTransform: 'uppercase' }}>
                        Filtros de Reporte
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size="medium"
                                type="date"
                                label="Desde"
                                value={desde}
                                onChange={(event) => { setDesde(event.target.value) }}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    '& .MuiInputBase-input': { fontSize: '1rem' }
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size="medium"
                                type="date"
                                label="Hasta"
                                value={hasta}
                                onChange={(event) => { setHasta(event.target.value) }}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    '& .MuiInputBase-input': { fontSize: '1rem' }
                                }}
                            />
                        </Grid>
                    </Grid>
                </Paper>

                {/* Resumen y Exportar */}
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 1.5,
                    px: 1
                }}>
                    <Chip
                        label={`${rows.length} movimientos`}
                        size="medium"
                        sx={{
                            backgroundColor: 'rgba(30, 58, 95, 0.1)',
                            color: '#1e3a5f',
                            fontWeight: 600,
                            fontSize: '0.875rem',
                            height: 32
                        }}
                    />
                    <ExportButtons
                        data={rows}
                        columns={[
                            { header: 'Fecha', field: 'fecha' },
                            { header: 'Concepto', field: 'nombre' },
                            { header: 'Disponible', field: 'disponible', type: 'money' },
                            { header: 'Acum. Disponible', field: 'acum_disponible', type: 'money' },
                            { header: 'Ganancia', field: 'ganancia', type: 'money' },
                            { header: 'Acum. Ganancia', field: 'acum_ganancia', type: 'money' }
                        ]}
                        filename="movimientos"
                        title="Consulta Detallada de Movimientos"
                    />
                </Box>

                {/* Tabla de resultados */}
                <Paper sx={{
                    borderRadius: 2,
                    boxShadow: 3,
                    overflow: 'hidden',
                    maxHeight: 550
                }}>
                    <Box sx={{ overflow: 'auto', maxHeight: 550 }}>
                        <Table stickyHeader size="medium">
                            <TableHead>
                                <TableRow>
                                    <TableCell rowSpan={2} sx={{
                                        background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                                        color: 'white',
                                        fontWeight: 600,
                                        fontSize: '0.9rem',
                                        py: 1.25,
                                        borderBottom: '2px solid #d4af37'
                                    }}>Fecha</TableCell>
                                    <TableCell rowSpan={2} sx={{
                                        background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                                        color: 'white',
                                        fontWeight: 600,
                                        fontSize: '0.9rem',
                                        py: 1.25,
                                        borderBottom: '2px solid #d4af37'
                                    }}>Concepto</TableCell>
                                    <TableCell sx={{
                                        textAlign: "center",
                                        background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                                        color: 'white',
                                        fontWeight: 600,
                                        fontSize: '0.9rem',
                                        py: 1
                                    }} colSpan={2}>Disponibilidad</TableCell>
                                    <TableCell sx={{
                                        textAlign: "center",
                                        background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                                        color: '#d4af37',
                                        fontWeight: 600,
                                        fontSize: '0.9rem',
                                        py: 1
                                    }} colSpan={2}>Ganancias</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ textAlign: "center", background: '#2c5282', color: 'white', fontSize: '0.85rem', py: 0.75, borderBottom: '2px solid #d4af37' }}>Monto</TableCell>
                                    <TableCell sx={{ textAlign: "center", background: '#2c5282', color: 'white', fontSize: '0.85rem', py: 0.75, borderBottom: '2px solid #d4af37' }}>Acum.</TableCell>
                                    <TableCell sx={{ textAlign: "center", background: '#2c5282', color: '#d4af37', fontSize: '0.85rem', py: 0.75, borderBottom: '2px solid #d4af37' }}>Monto</TableCell>
                                    <TableCell sx={{ textAlign: "center", background: '#2c5282', color: '#d4af37', fontSize: '0.85rem', py: 0.75, borderBottom: '2px solid #d4af37' }}>Acum.</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((row) => (
                                    <TableRow key={row.id} hover sx={{ '&:hover': { backgroundColor: 'rgba(44, 82, 130, 0.04)' } }}>
                                        <TableCell sx={{ color: '#1e3a5f', fontSize: '0.9rem', py: 1 }}>{row.fecha}</TableCell>
                                        <TableCell sx={{ color: '#1e3a5f', fontSize: '0.9rem', py: 1 }}>{row.nombre}</TableCell>
                                        <TableCell sx={{ textAlign: "right", color: '#1e3a5f', fontSize: '0.9rem', py: 1 }}>
                                            {parseFloat(row.disponible).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "right", color: '#4a5568', fontSize: '0.85rem', py: 1 }}>
                                            {parseFloat(row.acum_disponible).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "right", color: '#d4af37', fontWeight: 500, fontSize: '0.9rem', py: 1 }}>
                                            {parseFloat(row.ganancia).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "right", color: '#4a5568', fontSize: '0.85rem', py: 1 }}>
                                            {parseFloat(row.acum_ganancia).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <TableFooter>
                                <TableRow sx={{ backgroundColor: '#f8fafc' }}>
                                    <TableCell colSpan={6} sx={{ fontWeight: 600, color: '#1e3a5f', fontSize: '0.9rem', py: 1.5 }}>
                                        {"Total: " + rows.length + " movimientos"}
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </Box>
                </Paper>
            </Box>
        </Box>
    )
}